import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PurchaseOrderService {


  constructor(private http: HttpClient) { }
  
	url = environment.serverAPI5 + '/' + 'api/purchasesOrder';

	searchPurchasesOrder(query, Page: any, size: any, sort: any): Observable<Object> {
		return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
	}

	getPurchasesOrder(Page: number, size: number, sort: number): Observable<Object> {
		return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
	}

	getAllPurchasesOrderDropDown(): Observable<Object> {
		return this.http.get(`${this.url}/dropdown`);
	  }

	getPurchasesOrderById(id: number): Observable<Object> {
		return this.http.get(`${this.url}/${id}`);
	  }


	  getPurchasesOrderNo(purchaseOrderNo: any): Observable<Object> {
		return this.http.get(`${this.url}/no?purchaseOrderNo=${purchaseOrderNo}`);
	  }

	  deleteByPurchasesOrderId(id: any): Observable<Object> {
		return this.http.delete(`${this.url}/${id}`);
	}
	
 
	createPurchasesOrder(Purchase: any): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url}`, Purchase);
	}
	deleteImage(data: any): Observable<Object> {
		return this.http.post(`${this.url}/deleteImage`, data);
	}
	downloadPurchasesOrderTemplate(): Observable<any> {
		return this.http.get(`${this.url}/template/download`, {responseType: 'arraybuffer',observe: 'response' });
	  }
	  downloadPurchasesOrderReport(Page: number, size: number, sort,selectionPurchase): Observable<any> {
		return this.http.post(`${this.url}/export/page?page=${Page}
		&size=${size}&sort=${sort}`, selectionPurchase, { 
		  responseType: 'arraybuffer',
		  observe: 'response'
		});
	  }

	  searchPurchasesOrderReport(query: string, page: number, size: number, sort: string): Observable<Response[]> {


		const requestBody = {
		  "searchQuery": query != null ? query.split("'").join('') : null
		};
	
		const queryParams = `?page=${page}&size=${size}&sort=${sort}`;
	
		return this.http.post<Response[]>(`${this.url}/condition${queryParams}`, requestBody);
	  }
  }
